import moment from './moment'

export const isTimeFormatValid = (time) => {

  //Expected format '12:00'
  let splitedTime = time.split(":")

  if (splitedTime.length !== 2) {
    return false
  }

  if (splitedTime[0].length !== 2 || splitedTime[1].length !== 2) {
    return false
  }
  if(isNaN(splitedTime[0]) || isNaN(splitedTime[1])){
    return false
  }

  let hours = parseInt(splitedTime[0], 10)
  let minuts = parseInt(splitedTime[1], 10)
  return hours >= 0 && hours < 24 && minuts >= 0 && minuts < 60
}

export const formatMinutes = (mins, format) => {
  const hours = mins / 60 | 0
  const minutes = mins % 60 | 0
  return moment.utc().hours(hours).minutes(minutes).format(format)
}



// WEBPACK FOOTER //
// ./src/helpers/time.js